import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useLocation } from "react-router-dom";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import { ALL_USERS, DELETE_USER } from "../queries/GraphQLQueries";
import CustomAlert from "./CustomAlert";
import { useDialogNavigation } from "../hooks/useDialogNavigation";

export default function DeleteUserDialogBox() {
    const handleCancel = useDialogNavigation();
    const { state } = useLocation();
    const { userId, userName } = state || {};

    const [alertMessage, setAlertMessage] = useState(null);
    const [deleteUserMutation] = useMutation(DELETE_USER, {
        refetchQueries: [
            { query: ALL_USERS }, 'GetUsers'
        ]
    });

    const handleCloseCustomAlert = () => { setAlertMessage(null); };

    const handleDelete = () => {
        setAlertMessage({ children: 'Deleting User...', severity: 'success' });
        deleteUserMutation({
            variables: {
                id: userId
            }
        }).then(() => {
            handleCancel();
            setAlertMessage({ children: 'User deleted', severity: 'success' });
        }).catch((e) => {
            setAlertMessage({ children: e?.message, severity: 'error' });
        });
    };

    return <>
        <Dialog open={true} onClose={handleCancel} aria-labelledby="soft-delete-dialog-title"
            aria-describedby="soft-delete-dialog-description" disableRestoreFocus>

            <DialogTitle id="soft-delete-dialog-title">(Soft) Delete User?</DialogTitle>
            <DialogContent>
                <DialogContentText id="soft-delete-dialog-description">
                    Are you sure you want to (soft) delete "<b>{userName}</b>"? <br></br>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={handleDelete} color="primary" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
        <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert} />
    </>;
}